<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="促销分析名称">
          <el-input placeholder="请输入促销分析名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>

        <el-form-item label="类型" >
             <el-select v-model="formInline.table" filterable placeholder="请选择" >
              <el-option  label="优惠券" value="coupon"></el-option>
              <el-option  label="秒杀活动" value="seckill_activity"></el-option>
              <el-option  label="满送活动" value="fulldelivery"></el-option>
              <el-option  label="下单送券活动" value="oarcoupon"></el-option>
              <el-option  label="满减活动" value="fullreduce"></el-option>
              <el-option  label="每日特价" value="special_activity"></el-option>
              
          </el-select>
          </el-form-item>


        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>

          <el-button type="primary" icon="el-icon" @click="fx">分析（未删除）</el-button>
          <el-button type="primary" icon="el-icon" @click="fx1">分析（包含已删除）</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      

            <el-table-column prop="code" label="类型"></el-table-column>


            <el-table-column prop="name" label="活动名称"></el-table-column>
            <el-table-column prop="type_text" label="优惠券类型"></el-table-column>


            <el-table-column prop="use_num" label="使用/参与人数"></el-table-column>
            <el-table-column prop="discount_amount" label="优惠金额"></el-table-column>
            <el-table-column prop="amount" label="订单总额(不包含运费)"></el-table-column>
            <!-- <el-table-column prop="order_nums" label="订单数量"></el-table-column> -->

            <el-table-column prop="profitmargin" label="优惠比例">
              <template slot-scope="scope">
                <div v-if="scope.row.table !='seckill_activity' && scope.row.table !='special_activity' && scope.row.table !='coupon'">
                  <div v-if="scope.row.discount_amount && scope.row.amount && scope.row.discount_amount >0 && scope.row.amount > 0">
                    {{ ((scope.row.discount_amount/scope.row.amount).toFixed(4)) *100  }}%</div>
                </div>
                <div v-else>

                  <div v-if="scope.row.discount_amount && scope.row.amount && scope.row.discount_amount >0 && scope.row.amount > 0">
                    {{ ((scope.row.discount_amount/(parseFloat(scope.row.amount)+parseFloat(scope.row.discount_amount))).toFixed(4)) *100  }}%</div>
                </div>
              </template>

            </el-table-column>

            <el-table-column prop="use_num" label="是否删除">
              <template slot-scope="scope">

                <div v-if="scope.row.is_delete == 0">进行中</div>
                <div v-if="scope.row.is_delete == 1">已删除</div>
              </template>

            </el-table-column>

            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="jumpClick(scope.row.url,scope.row.id)" type="text" v-auth="'/plus/panalysis/index/jump'" size="small">跳转</el-button>
    
                <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/plus/panalysis/index/del'">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :panalysis_id="panalysis_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import PanalysisApi from '@/api/panalysis.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          table:""
        },

        open_add:false,
        open_edit:false,
        panalysis_id:"",
        dialogVisible:false,
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      jumpClick(url,id){
        this.$router.push({
            path: url,
            query: {
            id:id
            }
        });
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//促销分析标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
      fx(){
        let self = this;
        PanalysisApi.fx({type:1}, true)
          .then(data => {
            self.getTableList();
          })
          .catch(error => {
          });
      },
      fx1(){
        let self = this;
        PanalysisApi.fx({type:2}, true)
          .then(data => {
            self.getTableList();
          })
          .catch(error => {
          });
      },
      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        PanalysisApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.panalysis_id = row.panalysis_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            PanalysisApi.del(
              {
                panalysis_id: row.panalysis_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/panalysis/index/index.vue